import React, { useState, useEffect, Fragment } from 'react';
import Modal from '@material-ui/core/Modal';
import { Button } from 'reactstrap';
import moment from 'moment';
import ListRequestReschedule from './ListRequestReschedule';
import ListRequestRescheduleActions from './ListRequestRescheduleActions';

const ListRequestRescheduleModal = ({ opened, closeModal, setDataEvent, CallbackCalendar, dataReschedule, CallbackReschedule }) => {

  return (
    <Fragment>
      <Modal
        open={opened}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
        onClose={() => {
          closeModal();
        }}
      >
        <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
          <div className="card__title">
            <h5 className="bold-text">Lista de Solicitudes de Reagendamiento</h5>
          </div>
          <div>
            <ListRequestReschedule
              reactTableData={dataReschedule}
              setDataEvent={setDataEvent}
              ReactTableActions={ListRequestRescheduleActions}
              closeModalReschedule={() => closeModal()}
              CallbackCalendar={CallbackCalendar}
              CallbackReschedule={CallbackReschedule}
            />
          </div>
          <div style={{ display: 'flex', marginTop: 10, justifyContent: 'flex-end' }}>
            <Button
              style={{ marginRight: 10, marginLeft: 10 }}
              variant="contained"
              onClick={() => {
                closeModal();
              }}
            >
              Cerrar
            </Button>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

export default ListRequestRescheduleModal;
